import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { EntityRefOfInt64 } from './EntityRefOfInt64'
import { ProductAttributeValueSlotDto } from './ProductAttributeValueSlotDto'
/**
* Class ProductAttributesGroupDto
*  Информация о группах атрибутов
*/
export class ProductAttributesGroupDto extends ActiveModel {

  /**
  * group
  * Информация о группе атрибутов. <br><br>Если null, значит группа для атрибутов Web.Api.Showcases.Controllers.Products.Models.ProductAttributesGroupDto.Attributes отсутствует<br>  */
  @ActiveField({
    factory: [EntityRefOfInt64, () => undefined]
  })
  group?: null | EntityRefOfInt64


/**
  * @property attributes
  * Информация об атрибутах и их значениях для продукта в рамках канала<br>  */
  @ActiveField({
    factory: [ProductAttributeValueSlotDto, () => undefined]
  })
  attributes?: Array<ProductAttributeValueSlotDto>
}
